import {REACTIVATION_SERVICE_URL, CRM_URL_OPT_IN, CRM_URL_OPT_OUT} from './constants';

const dataType = 'json';
const contentType = 'application/json;charset=UTF-8';
const type = 'POST';

export default Backbone.Model.extend({
    defaults: {
        crmToken: null,
        infoToken: null,
        utmParameters: null,
        optOut: null,
        error: false,
    },

    url: function() {
        return Odigeo.Settings.getProperty('membershipServiceFormatter')(REACTIVATION_SERVICE_URL);
    },

    sendInfoToken() {
        this.fetch(this.getDataInfoTokenRequest());
    },

    getDataInfoTokenRequest() {
        return {
            data: this.get('infoToken'),
            dataType,
            contentType,
            type,
            error: () => this.set('error', true),
        };
    },

    getCrmUrlOpt() {
        return this.get('optOut') ? CRM_URL_OPT_OUT : CRM_URL_OPT_IN;
    },

    getCrmUtmParams() {
        return this.get('utmParameters') ? `&${this.get('utmParameters')}` : '';
    },
});
